
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { usePermissions } from '@/contexts/unified-permissions';
import { BlogService } from '@/services/blog/blogService';

export const useBlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated } = usePermissions();
  const [isAdmin, setIsAdmin] = useState(false);
  
  const { data: post, isLoading, error } = useQuery({
    queryKey: ['blogPost', slug],
    queryFn: async () => {
      if (!slug) throw new Error('Slug is required');
      
      const post = await BlogService.getPostBySlug(slug);
      
      if (!post) {
        throw new Error('Post not found');
      }
      
      return post;
    },
    enabled: !!slug
  });
  
  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!isAuthenticated) return;
      
      const { data, error } = await supabase.rpc('check_if_user_is_admin');
      if (error) {
        console.error('Error checking admin status:', error);
        return;
      }
      
      setIsAdmin(data === true);
    };
    
    checkAdminStatus();
  }, [isAuthenticated]);
  
  const handleLogin = () => {
    navigate('/auth/login');
  };

  const handleSignup = () => {
    navigate('/auth/signup');
  };
  
  const handleEditPost = () => {
    if (post?.id) {
      navigate(`/blog/admin/edit/${post.id}`);
    }
  };
  
  return {
    post,
    isLoading,
    error,
    isAdmin,
    handleLogin,
    handleSignup,
    handleEditPost,
    navigate
  };
};
